import { Provider } from '@angular/core';
import {
  InlineLoader,
  Translation,
  provideTranslocoScope,
} from '@jsverse/transloco';

import { createInlineLoader } from '../../../i18n/inline-loader.util';

const PAGE_HEADER_I18N_SCOPE = 'pageHeader';

const translations = {
  en: {
    logout: 'Logout',
    ariaUserMenu: 'User menu',
    ariaCloseUserMenu: 'Close user menu',
  },
  de: {
    logout: 'Abmelden',
    ariaUserMenu: 'Benutzermen\u00fc',
    ariaCloseUserMenu: 'Benutzermen\u00fc schlie\u00dfen',
  },
} satisfies Record<string, Translation>;

const pageHeaderLoader: InlineLoader = createInlineLoader(translations);

export const pageHeaderI18nProviders: Provider[] = provideTranslocoScope({
  scope: PAGE_HEADER_I18N_SCOPE,
  loader: pageHeaderLoader,
});
